/** Animaciones entrada/salida comunicación interna (popup + modal + filas). */
const STYLE_ID = "vc-msg-interna-anim-v2";

/** Duración de salida (debe coincidir con pedirCerrar / unmount). */
export const MSG_INTERNA_ANIM_MS = 520;

export function ensureMensajesInternosAnimCss() {
  if (typeof document === "undefined") return;
  // Ampliar: si quedó la v1, la quitamos; siempre reinyectamos la última.
  document.getElementById("vc-msg-interna-anim")?.remove();
  const prev = document.getElementById(STYLE_ID);
  if (prev) prev.remove();

  const s = document.createElement("style");
  s.id = STYLE_ID;
  s.textContent = `
@keyframes vcMsgBackdropIn {
  0% { opacity: 0; backdrop-filter: blur(0); -webkit-backdrop-filter: blur(0); }
  100% { opacity: 1; backdrop-filter: blur(10px); -webkit-backdrop-filter: blur(10px); }
}
@keyframes vcMsgBackdropOut {
  0% { opacity: 1; backdrop-filter: blur(10px); -webkit-backdrop-filter: blur(10px); }
  100% { opacity: 0; backdrop-filter: blur(0); -webkit-backdrop-filter: blur(0); }
}
@keyframes vcMsgPopIn {
  0% {
    opacity: 0;
    transform: translate3d(0, -140%, 0) scale(0.35) rotateX(42deg) rotateZ(-6deg);
    filter: blur(18px) brightness(1.6) saturate(1.4);
    box-shadow: 0 0 0 0 rgba(45,212,191,0);
  }
  45% {
    opacity: 1;
    transform: translate3d(0, 18px, 0) scale(1.1) rotateX(-4deg) rotateZ(1deg);
    filter: blur(0) brightness(1.15) saturate(1.2);
    box-shadow:
      0 0 0 3px rgba(45,212,191,0.55),
      0 0 100px 28px rgba(20,184,166,0.55),
      0 40px 80px rgba(0,0,0,0.45);
  }
  68% {
    transform: translate3d(0, -10px, 0) scale(0.96) rotateX(2deg) rotateZ(0);
    box-shadow:
      0 0 0 1px rgba(45,212,191,0.35),
      0 0 60px 12px rgba(20,184,166,0.35),
      0 28px 64px rgba(0,0,0,0.4);
  }
  100% {
    opacity: 1;
    transform: translate3d(0, 0, 0) scale(1) rotateX(0) rotateZ(0);
    filter: blur(0) brightness(1) saturate(1);
    box-shadow:
      0 28px 70px rgba(0,0,0,0.5),
      0 0 48px rgba(20,184,166,0.28);
  }
}
@keyframes vcMsgPopOut {
  0% {
    opacity: 1;
    transform: translate3d(0, 0, 0) scale(1) rotateX(0) rotateZ(0);
    filter: blur(0) brightness(1);
    box-shadow: 0 28px 70px rgba(0,0,0,0.5), 0 0 48px rgba(20,184,166,0.28);
  }
  35% {
    opacity: 1;
    transform: translate3d(0, 12px, 0) scale(1.06) rotateX(6deg);
    filter: brightness(1.2);
    box-shadow: 0 0 0 4px rgba(45,212,191,0.5), 0 0 90px 24px rgba(20,184,166,0.5);
  }
  100% {
    opacity: 0;
    transform: translate3d(0, -110%, 0) scale(0.28) rotateX(-38deg) rotateZ(8deg);
    filter: blur(22px) brightness(1.5);
    box-shadow: 0 0 0 0 rgba(45,212,191,0);
  }
}
@keyframes vcMsgModalIn {
  0% {
    opacity: 0;
    transform: translate3d(0, 80px, 0) scale(0.72) rotateX(18deg);
    filter: blur(14px) brightness(1.3);
    box-shadow: 0 0 0 0 rgba(20,184,166,0);
  }
  55% {
    opacity: 1;
    transform: translate3d(0, -14px, 0) scale(1.05) rotateX(-3deg);
    filter: blur(0) brightness(1.1);
    box-shadow:
      0 0 0 2px rgba(45,212,191,0.45),
      0 0 90px 20px rgba(20,184,166,0.4),
      0 40px 90px rgba(0,0,0,0.5);
  }
  100% {
    opacity: 1;
    transform: translate3d(0, 0, 0) scale(1) rotateX(0);
    filter: blur(0) brightness(1);
    box-shadow:
      0 28px 70px rgba(0,0,0,0.45),
      0 0 52px rgba(20,184,166,0.22);
  }
}
@keyframes vcMsgModalOut {
  0% {
    opacity: 1;
    transform: translate3d(0, 0, 0) scale(1) rotateX(0);
    filter: blur(0);
  }
  100% {
    opacity: 0;
    transform: translate3d(0, 90px, 0) scale(0.78) rotateX(-16deg);
    filter: blur(16px) brightness(1.25);
    box-shadow: 0 0 0 0 rgba(20,184,166,0);
  }
}
@keyframes vcMsgRowIn {
  0% {
    opacity: 0;
    transform: translate3d(-40px, 0, 0) scale(0.92);
    filter: blur(6px);
  }
  70% {
    opacity: 1;
    transform: translate3d(6px, 0, 0) scale(1.02);
    filter: blur(0);
  }
  100% {
    opacity: 1;
    transform: translate3d(0, 0, 0) scale(1);
  }
}
@keyframes vcMsgDetailIn {
  0% {
    opacity: 0;
    transform: translate3d(36px, 0, 0) scale(0.9) rotateY(-8deg);
    filter: blur(8px);
  }
  100% {
    opacity: 1;
    transform: translate3d(0, 0, 0) scale(1) rotateY(0);
    filter: blur(0);
  }
}
@keyframes vcMsgGlowPulse {
  0%, 100% { opacity: 0.35; transform: scale(0.92); }
  50% { opacity: 0.85; transform: scale(1.08); }
}

.vc-msg-backdrop-in,
.vc-msg-backdrop-out {
  perspective: 1400px;
  transform-style: preserve-3d;
}
.vc-msg-backdrop-in { animation: vcMsgBackdropIn 480ms ease-out both; }
.vc-msg-backdrop-out { animation: vcMsgBackdropOut ${MSG_INTERNA_ANIM_MS}ms ease-in both; }

.vc-msg-pop-in,
.vc-msg-pop-out,
.vc-msg-modal-in,
.vc-msg-modal-out {
  transform-origin: 50% 20%;
  transform-style: preserve-3d;
  will-change: transform, opacity, filter, box-shadow;
  backface-visibility: hidden;
}
.vc-msg-pop-in { animation: vcMsgPopIn 700ms cubic-bezier(0.16, 1.12, 0.3, 1) both; }
.vc-msg-pop-out { animation: vcMsgPopOut ${MSG_INTERNA_ANIM_MS}ms cubic-bezier(0.55, 0.05, 0.8, 0.4) both; }
.vc-msg-modal-in { animation: vcMsgModalIn 650ms cubic-bezier(0.16, 1.1, 0.3, 1) both; }
.vc-msg-modal-out { animation: vcMsgModalOut ${MSG_INTERNA_ANIM_MS}ms cubic-bezier(0.55, 0.05, 0.8, 0.4) both; }
.vc-msg-row-in { animation: vcMsgRowIn 480ms cubic-bezier(0.16, 1.15, 0.3, 1) both; }
.vc-msg-detail-in { animation: vcMsgDetailIn 460ms cubic-bezier(0.16, 1.1, 0.3, 1) both; }

.vc-msg-pop-in::before,
.vc-msg-modal-in::before {
  content: "";
  position: absolute;
  inset: -30%;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(45,212,191,0.45) 0%, transparent 62%);
  pointer-events: none;
  z-index: -1;
  animation: vcMsgGlowPulse 900ms ease-out 1 both;
}
`;
  document.head.appendChild(s);
}

/** Normaliza propiedades de un mensaje (array o legacy propiedad_id). */
export function propsDeMensaje(m) {
  if (!m) return [];
  if (Array.isArray(m.propiedades) && m.propiedades.length) {
    return m.propiedades.map((p) => ({
      id: p.id,
      referencia: p.referencia || p.propiedad_referencia,
      etiqueta: p.etiqueta || p.propiedad_etiqueta,
    }));
  }
  if (m.propiedad_id) {
    return [
      {
        id: m.propiedad_id,
        referencia: m.propiedad_referencia,
        etiqueta: m.propiedad_etiqueta,
      },
    ];
  }
  return [];
}
